import { v4 as uuidv4 } from 'uuid';

import { dispatchPromise, fetchResources } from './action-helpers';

import { getCurrentUserId } from '../services/store-service';

const DEFAULT_FILE_PROPS = {
    id: null,
    name: '',
    project: undefined,
    task: undefined,
    size: 0,
    thumbnail: '',
    uploader: null,
    url: ''
};

export const startFilesProcess = files => {
    files.forEach(file => {
        dispatchPromise({
            type: 'FILE_PROCESS_START',
            payload: {
                file: {
                    size: file.size || file.sizeBytes,
                    name: file.name
                }
            }
        });
    });
}

export const endFilesProcess = files => {
    files.forEach(file => {
        dispatchPromise({
            type: 'FILE_PROCESS_END',
            payload: {
                file: {
                    size: file.size || file.sizeBytes,
                    name: file.name
                }
            }
        });
    });
}

export const uploadFiles = (files, fileProps) => {
    files.forEach(file => {
        dispatchPromise({
            type: 'FILE_UPLOAD_START',
            payload: {
                file: {
                    size: file.size || file.sizeBytes,
                    name: file.name
                }
            }
        });
    });

    return dispatchPromise({
        type: 'FILES_UPLOAD_REQUESTED',
        payload: {
            files,
            filesSimple: files.map(file => ({
                name: file.name,
                size: file.size
            })),
            fileProps: Object.assign({}, DEFAULT_FILE_PROPS, fileProps, {
                id: uuidv4(),
                uploader: getCurrentUserId()
            })
        }
    }).catch(e => {
        files.forEach(file => {
            dispatchPromise({
                type: 'FILE_UPLOAD_ERROR',
                payload: {
                    file: {
                        size: file.size || file.sizeBytes,
                        name: file.name
                    }
                }
            });
        })
    })
}

export const fetchFiles = (fetchProps, all) => fetchResources('FILES_FETCH_REQUESTED', fetchProps, all);

export const fetchFile = fileId => {
    return dispatchPromise({
        type: 'FILE_FETCH_REQUESTED',
        payload: { fileId }
    });
}

export const updateFile = (fileId, fileProps, preventSave) => {
    return dispatchPromise({
        type: 'FILE_UPDATE_REQUESTED',
        preventSave,
        payload: {
            fileId,
            fileProps
        }
    });
}

export const addFileLabel = (fileId, labelId) => {
    return addFileLabels(fileId, [labelId]);
}

export const addFileLabels = (fileId, labels) => {
    return dispatchPromise({
        type: 'FILE_LABELS_ADD_REQUESTED',
        payload: {
            fileId,
            labels
        }
    });
}

export const removeFileLabel = (fileId, labelId) => {
    return removeFileLabels(fileId, [labelId])
}

export const removeFileLabels = (fileId, labels) => {
    return dispatchPromise({
        type: 'FILE_LABELS_REMOVE_REQUESTED',
        payload: {
            fileId,
            labels
        }
    });
}

export const removeFile = fileId => {
    return dispatchPromise({
        type: 'FILE_REMOVE_REQUESTED',
        payload: { fileId }
    });
}


export const removeFiles = fileIds => {
    return dispatchPromise({
        type: 'FILES_REMOVE_REQUESTED',
        payload: { fileIds }
    });
}

export const copyFile = (fileId, copyOptions) => {
    return dispatchPromise({
        type: 'FILE_COPY_REQUESTED',
        payload: {
            fileId,
            copyOptions
        }
    });
}

export const reloadUploading = () => {
    return dispatchPromise({
        type: 'FILE_RELOAD_UPLOADING'
    });
}

export const refetchProjectFiles = projectId => {
    return dispatchPromise({
        type: 'REFETCH_PROJECT_FILES',
        payload: {
            projectId
        }
    });
}
